import { NgModule } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CustomCmsService } from './facade/custom-cms.service';
import { CoreStoreModule } from './store/core-store.module';

@NgModule({
  imports: [CoreStoreModule],
  providers: [
    {
      provide: CmsService,
      useExisting: CustomCmsService,
    },
  ],
})
export class CoreDataAccessModule {}
